<template>
  <div>
    <QS-h4-title title="订单收款信息" />
    <div class="details_content_repeat_btns">
      <el-button type="primary" :disabled="batchOfflineCollectAble" @click="batchOfflineCollect">
        批量线下收款
      </el-button>
      <i class="cut-off"></i>
      <el-button @click="showDialog">订单收款记录</el-button>
    </div>
    <!-- 收款信息列表 -->
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <QS-common-table ref="receiptBLMCommonTable"
      :header-cell-class-name="cellClass"
      v-loading="loading"
      :columns="columns"
      :pagination="pagination"
      :data="receiptData"
      @change="pageChange"
      @select="selectionChangeEventForOverdue"
      @select-all="selectionAllChangeEventForOverdue"
    />
    <receiptRecordList :isShowDialog="isShowDialog"  @closeDialog="closeDialog"/>
  </div>
</template>

<script>
import { getReceivableList } from '@/api/domain/returnLease'
import selectOption from '@/store/dict/selectOptionDict'
import { mapState } from 'vuex'
import config from './config'
import receiptRecordList from './components/receiptRecord'
import { batchOfflineCollectCheck, overdueUtils } from '@/pages/utils/overdue'

export default {
  inject: ['orderData'],
  components: { receiptRecordList },
  data() {
    const { columns, pagination } = config.call(this)
    const { selectionAllChangeEventForOverdue, selectionChangeEventForOverdue } = overdueUtils.call(this)
    return {
      selectionAllChangeEventForOverdue,
      selectionChangeEventForOverdue,
      columns,
      pagination,
      loading: false,
      // 收款被选中项
      receiptSelectedItems: [],
      receiptData: [],
      isShowDialog: false,
    }
  },
  computed: {
    batchOfflineCollectAble() {
      return !this.receiptSelectedItems.length
    },
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
    this.getReceivableList()
  },
  methods: {
    showDialog() {
      this.isShowDialog = true
    },
    closeDialog() {
      this.isShowDialog = false
    },
    // 批量线下收款能力
    batchOfflineCollect() {
      // 筛选出所有订单ID
      const idList = this.receiptSelectedItems.map((obj) => obj.id).join(',')
      batchOfflineCollectCheck(idList).then((res) => {
        if (res?.code === 1) {
          this.$emit('setIdList', idList)
        }
      })
    },
    cellClass(row) {
      // this.receiptData = []
      // 获取可选数据的条数的长度（剩余应收金额为0，item.remainAmount === 0 ）
      const len = this.receiptData.filter((item) => !(Number(item.remainAmount) === 0 || item.receivableState === '已完成' || item.receivableState === '已关闭')).length
      if (row.columnIndex === 0 && !len) { return 'disableSelection' }
    },
    // 应收列表
    async getReceivableList() {
      this.loading = true
      const { code, data } = await getReceivableList({
        sourceOrderId: this.orderData.id,
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
      })
      this.loading = false
      if (code !== 1) return
      this.receiptData = data.items
        ? data.items.map((item) => {
          return {
            ...item,
            changeState: selectOption.payeechange[item.changeState],
            receivableState: selectOption.completionStatusDict[item.receivableState],
            content: this.formatEnumeration(this.freeTypeList)[item.content],
          }
        })
        : []
      this.pagination.total = data.totalNum
    },
    pageChange(payload) {
      this.pagination.pageNum = payload.pagination.pageNum
      this.pagination.pageSize = payload.pagination.pageSize
      this.getReceivableList()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .disableSelection .cell .el-checkbox__inner {
    display: inline-block;
    position: relative;
    border-radius: 2px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-color: #DCDFE6;
    background-color: #F5F7FA;
    cursor: not-allowed;
    z-index: 1;
}
</style>
